// Предпроверка платной кнопки по балансу профиля (utils/credits — правила, здесь только привязка к контексту входа).
// Гостю и вне AuthProvider (тесты, витрины) ничего не выключаем: гостя гейтит вход. Использование:
//   const guard = useCreditsGuard()
//   disabled={… || guard.shortFor(price)} title={guard.shortFor(price) ? guard.titleFor(price) : …}
//   {guard.shortFor(price) && <CreditsShortNote />}
import { useContext } from 'react'
import { AuthContext } from '../context/AuthContext'
import { isShort, shortTitle } from '../utils/credits'

export function useCreditsGuard(price?: number | null, opts: { from?: boolean } = {}) {
	const user = useContext(AuthContext)?.user ?? null
	const balance = Number(user?.credits_balance ?? 0)
	const shortFor = (p: number | null | undefined): boolean => !!user && isShort(balance, p)
	const titleFor = (p: number): string => shortTitle(p, balance, opts.from)
	const short = shortFor(price)
	return { balance, short, title: short && price != null ? titleFor(price) : null, shortFor, titleFor }
}
